import React from 'react';
import { Link } from 'react-router-dom';
// import { Button, Space } from 'antd';
// import { motion } from "framer-motion";

import Slider from "./misc/BannerSlider";

// Images
import logo from '../assets/images/logo-white.png';

// Component
// import SharePromo from '../components/misc/sharePromo';

const WelcomePages = ({
    children,
    type="static",
    single="",
    slider=[],
    current=""
}) => {   
    return (
        <div className="min-h-screen sm:h-screen w-screen relative">
            <div className="h-8 sm:h-12 bg-primary w-full flex--basic relative">
                <div className="hidden sm:block absolute z-50"
                    style={{bottom: '-4rem', left: '3rem'}}
                >
                    <div className="bg-primary pb-2 w-16 h-16 flex--basic">
                        <div className="flex--basic">
                            <Link to="/">
                                <img src={logo} className="h-full w-full" alt="prime_logo" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="text-white text-center text-sm sm:text-base tracking-widest">
                    MERCHANT E-GIFT CARD DASHBOARD
                </div>
            </div>
            
            <div className="h-3 bg-secondary w-full" />

            <section className="flex flex-wrap w-full pb-20 sm:pb-0"
                style={{ height: 'calc(100% - 7rem)' }}
            >
                <div className="w-full sm:w-5/12 relative bg-white flex justify-center sm:items-center pt-10 sm:pt-0 h-full">
                    <section className="w-full flex flex-col items-center">
                        {children}
                        <div className="text-sm pt-8 text-center leading-normal">
                            <i>"We only have what we give" by <b>Isabel Allende</b></i>
                        </div>
                    </section>
                </div>
                <div className="hidden sm:block w-full sm:w-7/12 h-full bg-gray-200">
                    {type === 'static' ?
                        <div className="bg-cover bg-no-repeat w-full h-full bg-gray-200" style={{background: `url(${single})`}} />
                    :
                        <Slider cards={slider} />
                    }
                </div>
            </section>

            <div className="absolute bottom-0 w-full">
                <div className="w-full py-5 bg-primary flext--basic">
                    <div className="text-sm text-center text-white leading-normal">
                    <span className="pr-1">Need Help please contact any of our Prime Support Team to assist you. </span> Email: <a href="mailto:support@20pesewas.com" target="_blank" rel="noopener noreferrer" className="text-white hover:underline pl-1"> support@20pesewas.com</a> <span className="px-1">•</span> <a href="tel:+233247117448" className="text-white hover:underline">+233 24 711 7448</a>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default WelcomePages;